












































import { Vue, Component, Inject, Watch, Prop } from "vue-property-decorator";

// Types
import {
  IBasketProviderData,
  IBasketProviderMethods
} from "@/models/providers/baskets";

@Component
export default class BasketCurrencySwitcher extends Vue {
  // Inject

  @Inject({ from: "basketProviderData" })
  public readonly $basketData!: () => IBasketProviderData;

  @Inject({ from: "basketProviderMethods" })
  public readonly $basketMethods!: IBasketProviderMethods;

  // Props

  @Prop({ default: false })
  public readonly forceShow!: boolean;

  // Data

  public currencyCode = this.basketData.currencyCode;

  // Computed

  public get basketData() {
    return this.$basketData();
  }

  public get currentCurrency() {
    return (
      this.$_.find(this.basketData.supportedCurrencies, [
        "code",
        this.currencyCode
      ]) || this.basketData.basket?.currency
    );
  }

  public get isProcessing() {
    return this.basketData.currencyIsSwitching || this.basketData.isProcessing;
  }

  public get showCurrencySwitcher() {
    const { basketIsComplete, supportedCurrencies } = this.basketData;
    if (basketIsComplete) return false;
    return this.forceShow || supportedCurrencies.length > 1;
  }

  // Methods

  @Watch("basketData.currencyCode")
  onCurrencyChange() {
    this.currencyCode = this.basketData.currencyCode;
  }
}
